import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2997c60c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2997c60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2997c60c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2997c60c')) {
      api.createRecord('2997c60c', component.options)
    } else {
      api.reload('2997c60c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2997c60c&scoped=true&", function () {
      api.rerender('2997c60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/department/compoments/Users/index.vue"
export default component.exports